import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(5),
  height: "95vh",
}));

export const Header = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
});

export const Content = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  gap: theme.spacing(3),
}));

export const Left = styled("div")(({ theme }) => ({
  flex: 3,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),

  ["& :nth-of-type(1)"]: {
    flex: 9,
  },
  ["& :nth-of-type(2)"]: {
    flex: 2,
  },
}));

export const Right = styled("div")(({ theme }) => ({
  flex: 9,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
}));

export const VideoDetails = styled("div")(({ theme }) => ({
  flex: 2,
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  width: "65%",

  ["& :nth-of-type(1)"]: {
    flex: 1,
  },
  ["& :nth-of-type(2)"]: {
    flex: 1.5,
  },
}));
